import CoversPage from '@/views/covers/CoversPage'

export default function FormsScreen() {
  return <CoversPage />
}
